// extracted by mini-css-extract-plugin
export default {"popupContainer":"ApmG8cghMOF6FXHzl294","skeletonContainer":"FaFxKl77EY1mv1Pk3X7J"};